// ======================================================================
// File Name       : enterpriseNotice
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

export const ENTERPRISE_NOTICE_EDIT = 'ENTERPRISE_NOTICE_EDIT';
export const ENTERPRISE_RECEIVED_NOTICE_SECERN_ID = 'ENTERPRISE_RECEIVED_NOTICE_SECERN_ID';
export const ENTERPRISE_RECEIVED_NOTICE_SECERN_DETAIL = 'ENTERPRISE_RECEIVED_NOTICE_SECERN_DETAIL';
